

const INIT_STATE = {
  itemPaymentData: {},
  bascketCarts: '',
  lastOne: null,
  cartsProduct: null,
  productCount: 0,
  shopVitrinList: []
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case 'itemOveral':
      state.itemPaymentData = action.payload.itemPaymentData;
      return { ...state };
    case 'lastOne':
      state.lastOne = action.payload.quantity;
      return { ...state };
    case 'carts':
      state.bascketCarts = action.payload.bascketCarts;
      return { ...state };
    case 'cartsProduct':
      state.cartsProduct = action.payload.cartsProduct;
      return { ...state };

    case 'productCount':
      state.productCount = action.payload.productCount;
      return { ...state };

    case 'shopVitrinList':
      state.shopVitrinList = action.payload.shopVitrinList;
      return { ...state };

    default:
      return { ...state };
  }
}